export const addToIvrPath = (ivrPath: string, valueToAdd: string) => {
    let splitIvrPath = ivrPath.split(",");
    splitIvrPath.push(valueToAdd);
    // filter out any empty strings
    splitIvrPath = splitIvrPath.filter((value: string) => value.trim().length > 0);
    return splitIvrPath.join(",");
};
